import { Button, Switch, Cell, CellGroup, Icon, Stepper,Field,Popup} from "vant";
import Header from './Header'
import PullRefresh from './PullRefresh';
import PhysicalKey from './physical-key'

// 全局组件
export let global = {
    // vant 组件
    [Button.name]: Button,
    [Switch.name]: Switch,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Stepper.name]: Stepper,
    [Field.name]:Field,
    [Popup.name]:Popup,
    // 自定义组件
    AppHeader: Header,
    PullRefresh: PullRefresh,
    PhysicalKey: PhysicalKey
};
